import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import { NotificationWrapper } from '../../main/components/notification'
import { SpecificChartFunctionality } from '../../main/constants/common'
import { MapContext } from '../maps/components/MapContext'
import { CryptoMapApp } from '../maps/crypto'
import { ResizableChartLayoutWithGlobalState } from '../shared/components/ResizableChartLayoutWithGlobalState'
import { ready } from '../shared/ready'
import { parseInitData } from '../shared/utils'
import CryptoActionCreators from './actions/cryptoActionCreators'
import CryptoCharts from './charts'
import CryptoPerformance from './performance'
import CryptoQuotes from './quotes'
import { TileMap } from './types'

window['FinvizInitCrypto'] = function (tiles: TileMap) {
  CryptoActionCreators.initTiles(tiles)
  const rootEl = document.getElementById('crypto')
  const root = ReactDOMClient.createRoot(rootEl!)
  root.render(<CryptoQuotes />)
}

window['FinvizInitCryptoPerformance'] = function (rows: Record<string, number>) {
  const rootEl = document.getElementById('futures')
  const root = ReactDOMClient.createRoot(rootEl!)
  root.render(<CryptoPerformance rows={rows} />)
}

window['FinvizInitCryptoCharts'] = function () {
  const cryptoEl = document.getElementById('crypto')
  const dataEl = document.getElementById('crypto-init-data')
  if (!cryptoEl || !dataEl) return

  try {
    const initData = parseInitData<TileMap>('crypto-init-data')
    void CryptoActionCreators.update(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(cryptoEl)

  root.render(
    <BrowserRouter>
      <CryptoCharts />
    </BrowserRouter>
  )
}

window['FinvizInitCryptoMaps'] = function () {
  const rootEl = document.getElementById('root')
  const initDataElement = document.getElementById('map-init-data')!
  const initData = JSON.parse(initDataElement.textContent!)

  const root = ReactDOMClient.createRoot(rootEl!)

  root.render(
    <MapContext>
      <CryptoMapApp {...initData} />
    </MapContext>
  )
}

ready(function () {
  const cryptoEl = document.getElementById('crypto')
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const dataEl = document.getElementById('crypto-init-data')

  if (!cryptoEl || !chartEl || !dataEl || !window.globalChartConfig) return

  try {
    const initData = parseInitData<TileMap>('crypto-init-data')
    void CryptoActionCreators.update(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(chartEl)

  root.render(
    <BrowserRouter>
      <NotificationWrapper>
        {ReactDOM.createPortal(<CryptoCharts />, cryptoEl)}
        <Suspense fallback={null}>
          <ResizableChartLayoutWithGlobalState
            specificChartFunctionality={SpecificChartFunctionality.cryptoPage}
            config={window.globalChartConfig}
          />
        </Suspense>
      </NotificationWrapper>
    </BrowserRouter>
  )
})
